import React, { Component } from 'react';
import _moment, { Moment } from 'moment';
import { extendMoment } from 'moment-range';
import DateRangePicker from 'react-daterange-picker';
import { getImage } from '../../utils';
import 'react-daterange-picker/dist/css/react-calendar.css';
import './styles.scss';
import DateRange from '../../assets/icons/date_range.svg';
import DownArrow from '../../assets/icons/down_arrow.svg';
import DateImg from '../../assets/icons/date_range_shadow.svg';
import NormalFilter from '../../assets/icons/filter.svg';
import WhiteFilter from '../../assets/icons/whitefilter.svg';

type Props = {
  endDate: Moment;
  startDate: Moment;
  onDateSelection: Function;
  fromRanking?: string;
  dateFilter?:string;
  clearDateFilterValue?:boolean;
  notificationToaster?:Function;
};
type State = {
  dateName: string;
  isMenuOpen: boolean;
  isPickerOpen: boolean;
  normaldatefilter:string;
  // value:any;
  // datestart:Moment;
  // dateend:Moment;
};

export default class DatePicker extends Component<Props, State> {
  // @ts-ignore
  moment = extendMoment(_moment);
  today = this.moment().clone();
  yesterday = this.today.clone().subtract(1, 'days');
  lastWeek = this.yesterday.clone().subtract(7, 'days');
  private myRef: React.RefObject<HTMLInputElement>;
  constructor(props: Props) {
    super(props);
    this.state = this.setIntitialState();
    this.myRef = React.createRef();
  }

  setIntitialState(): State {
    return {
      dateName: 'Today',
      isMenuOpen: false,
      isPickerOpen: false,
      normaldatefilter:'true',
      // value:this.moment.range(this.today, this.today)
      // datestart:this.moment().clone(),
      // dateend:this.moment().clone()
    };
  }


  // shouldComponentUpdate(nextProps:Props, nextState:State) {
  //   if(nextProps.startDate !== this.state.datestart){
  //   return true;
  //   }
  //   else{
  //     return false;
  //   }
  // }


  // componentWillReceiveProps(nextProps:Props){
  //   console.log('datepicker');
  //   if(nextProps.startDate !== this.state.datestart){
  //   this.setState({
  //     datestart:nextProps.startDate
  //   })
  //   }
  //   if(nextProps.endDate !== this.state.dateend){
  //     this.setState({
  //       datestart:nextProps.endDate
  //     })
  //     }
  // }
  componentDidMount() {
    // this.setState({
    //   datestart:this.props.startDate,
    //   dateend:this.props.endDate
    // })
    document.addEventListener('click', this.handleClickOutside);
    if (
      this.moment(this.today).format('DD MMM, YYYY') ===
        this.moment(this.props.startDate).format('DD MMM, YYYY') &&
      this.moment(this.today).format('DD MMM, YYYY') ===
        this.moment(this.props.endDate).format('DD MMM, YYYY')
    ) {
      this.setState({
        dateName: 'Today',
      });
    } else if (
      this.moment(this.yesterday).format('DD MMM, YYYY') ===
        this.moment(this.props.startDate).format('DD MMM, YYYY') &&
      this.moment(this.yesterday).format('DD MMM, YYYY') ===
        this.moment(this.props.endDate).format('DD MMM, YYYY')
    ) {
      this.setState({
        dateName: 'Yesterday',
      });
    } else if (
      this.moment(this.lastWeek).format('DD MMM, YYYY') ===
      this.moment(this.props.startDate).format('DD MMM, YYYY')
    ) {
      this.setState({
        dateName: 'Last week',
      });
    } else {
      this.setState({
        dateName: this.date,
      });
    }
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
  handleClickOutside = (event: any) => {
        if (this.myRef.current && !this.myRef.current.contains(event.target)) {
      this.setState({
        isMenuOpen: false,
      });
    }
  };
calculateDays(date1:any, date2:any) {
    let oned = 24 * 60 * 60 * 1000;
    return Math.ceil((date2 - date1) / oned);
 }
  dateChangeHandler(start: Moment, end: Moment, dateName?: string) {
   
    // console.log(this.calculateDays(start,end))
    if(this.calculateDays(start,end)+1 > 31){
      this.props.notificationToaster && this.props.notificationToaster("Please select a date range of 31 days or less");

    }
    else{
      if(dateName=="Today"){
        var today = new Date();
        var todayStartTime =
          today.getFullYear() +
          '-' +
          (today.getMonth() + 1) +
          '-' +
          today.getDate() +
          ' 00:00:00';
        var todayEndTime =
          today.getFullYear() +
          '-' +
          (today.getMonth() + 1) +
          '-' +
          today.getDate() +
          ' 23:59:59';
          this.props.onDateSelection(this.moment(todayStartTime), this.moment(todayEndTime),'Today');
      }
      else if(dateName==="Yesterday"){
        var yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        var yesterdayStartTime =
        yesterday.getFullYear() +
        '-' +
        (yesterday.getMonth() + 1) +
        '-' +
        yesterday.getDate() +
        ' 00:00:00';
      // yesterday.setDate(yesterday.getDate() - 1);
      var yesterdayEndTime =
        yesterday.getFullYear() +
        '-' +
        (yesterday.getMonth() + 1) +
        '-' +
        yesterday.getDate() +
        ' 23:59:59';
          this.props.onDateSelection(this.moment(yesterdayStartTime), this.moment(yesterdayEndTime),'Yesterday');
      }
      else if(dateName=="Last week"){
  //       var newStartTime =
  //    start.format('YYYY-MM-DD') +
  //   ' 00:00:00';
  // var newEndTime =end.format('YYYY-MM-DD')+' 23:59:59';
  // this.props.onDateSelection(this.moment(newStartTime), this.moment(newEndTime));
  var today = new Date();

  var todayEndTime =
    today.getFullYear() +
    '-' +
    (today.getMonth() + 1) +
    '-' +
    today.getDate() +
    ' 23:59:59';

  today.setDate(today.getDate() - 7);

  var todayStartTime =
    today.getFullYear() +
    '-' +
    (today.getMonth() + 1) +
    '-' +
    today.getDate() +
    ' 00:00:00';
    this.props.onDateSelection(this.moment(todayStartTime), this.moment(end),'Last week');
      }
      else{
        this.props.onDateSelection(start, end);
       }
  // console.log(start)
      this.setState({
        isMenuOpen: false,
        isPickerOpen: false,
        dateName: dateName || this.date,
        // value:  this.moment.range(start, end)
        // states
      },()=>{
        if(this.props.dateFilter === 'true'){
          var filterElements=Array.from(document.getElementsByClassName('ended-chat-filter-image') as HTMLCollectionOf<HTMLElement>)
          filterElements[0].style.backgroundColor=' #ef4078';
          this.setState({
            normaldatefilter:'false'
          })
        }
      });
    }
  
  }

  get date(): string {
    return `${this.moment(this.props.startDate).format('DD MMM, YYYY')} - ${this.moment(
      this.props.endDate
    ).format('DD MMM, YYYY')}`;
  }

  render() {
    return (
      <div className='sf-datepicker' ref={this.myRef}   
      style={
        this.props.dateFilter === 'true'?
        { marginTop:'0px' }:
        {}
       }>
   
          {this.props.dateFilter === 'true' ? (

        <div
          id='date'
          className={`clickable ${
            this.props.dateFilter === 'true' ? 
            'ended-filter-date-picker' : ''
          }`}
          onClick={() => {
            this.setState((prevState) => ({
              isMenuOpen: !prevState.isMenuOpen,
            }));
          }}>
       
          <img
            src={
         //   this.state.normaldatefilter==='true' || 
           this.props.clearDateFilterValue ===true ?
              NormalFilter:
              WhiteFilter
            }
            alt='filter'
          />

        </div>
          ):
          (
            <div
            id='date'
            className={`clickable ${
              this.props.fromRanking === 'true' ? 'ranking-date-picker' : ''
            }`}
            onClick={() => {
              this.setState((prevState) => ({
                isMenuOpen: !prevState.isMenuOpen,
              }));
            }}>
            {this.props.fromRanking === 'true' ? (
              <></>
            ) : (
              <img src={DateRange} alt='date range' style={{ marginRight: '5px' }} />
            )}
  
            <span
              style={
                this.props.fromRanking === 'true'
                  ? { fontSize: '14px', lineHeight: '1.36', color: 'rgba(0, 0, 0, 0.6)' }
                  : { fontSize: '16px' }
              }>
              {this.state.dateName}
            </span>
            <img
              src={DownArrow}
              alt='dropdown'
            />
          </div>
          )
          
          }
        <div
          id='picker-menu'
        
          style={ 
            this.props.dateFilter === 'true' ? 
          { display: this.state.isMenuOpen ? 'block' : 'none' , left:'-310%', top:"40px"}:
          { display: this.state.isMenuOpen ? 'block' : 'none'}
          
          }>
            
          <div
           style={
            this.props.dateFilter === 'true'?
            { display: 'none' }:
            {}
           }
            className='date-item clickable'
            onClick={() => {
              this.dateChangeHandler(this.today, this.today, 'Today');
            }}>
            Today
          </div>
          <div
           style={
            this.props.dateFilter === 'true'?
            { display: 'none' }:
            {}
           }
            className='date-item clickable'
            onClick={() => {
              this.dateChangeHandler(this.yesterday, this.yesterday, 'Yesterday');
            }}>
            Yesterday
          </div>
          <div
           style={
            this.props.dateFilter === 'true'?
            { display: 'none' }:
            {}
           }
            className='date-item clickable'
            onClick={() => {
              this.dateChangeHandler(this.lastWeek, this.yesterday, 'Last week');
            }}>
            Last week
          </div>
          <div style={
            this.props.dateFilter === 'true' && this.props.clearDateFilterValue ===false?
                    { borderBottom:'solid 1px rgba(0, 0, 0, 0.2)',
                      margin:'15px',
                      marginBottom:'5px',
                      paddingBottom:'10px',
                      justifyContent:'center',
                      color: '#000000',
                      fontSize:'15px',
                      fontWeight:'bold'
                    }:
                    {}
                       }
            className='date-item clickable'
            onClick={() => {
              this.setState((prevState) => ({
                isPickerOpen: !prevState.isPickerOpen,
              }));
            }}>
              
            {
             
           this.props.clearDateFilterValue ===true? '' : this.date }
           
            <img src={DateImg} alt='calendar'   
            style={
              this.props.dateFilter === 'true'?
            { display: 'none' }:
            {}
           }
           />
          </div>
          <div
            id='picker'
            style={
              this.props.dateFilter === 'true'?
              { display: 'block' }:
              { display: this.state.isPickerOpen ? 'block' : 'none' }}>
            <DateRangePicker
              maximumDate={new Date()}

             value={
                this.props.clearDateFilterValue===true?
               this.moment.range(this.today, this.today)
              :
              // this.state.value
               this.moment.range(this.props.startDate, this.props.endDate)
              // this.moment.range(this.state.datestart, this.state.dateend)
            }
              onSelect={(range: any) => {
                this.dateChangeHandler(range.start, range.end);
              }}
              singleDateRange={true}
              numberOfCalendars={1}
            />
          </div>
        </div>
      </div>
    );
  }
}
